<template>
  <div
    v-if="entries.length == 0"
    class="no-entries"
  >
    {{ $t('common.noEntries') }}
  </div>
</template>

<script>
export default {
  name: 'NoEntriesMessage',

  props: {
    entries: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.no-entries {
  text-align: center;
  padding: 100px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/NoEntriesMessage.vue